import type { IconProps } from "./types"

function SvgStop(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      //fill="currentColor"
      fill= "rgb(255,255,255)"
      {...props}
    >
      <rect
        x="3"
        y="3"
        width="19"
        height="19"
        rx="2.5"
        ry="2.5"
      />
    </svg>
  )
}

export default SvgStop